import { pipe } from "fp-ts/lib/function";
import { useEffect, useMemo } from "react";
import * as E from "fp-ts/Either";
import * as O from "fp-ts/Option";
import { ProtocolInstance } from "@silo/types";
import { useLocalStorage } from "@silo/ui";

export const usePersistedProtocolInstance = () => {
  const [maybePersistedProtocolInstance, setPersistedProtocolInstance, remove] =
    useLocalStorage<ProtocolInstance | undefined>(
      "selectedProtocolInstance",
      undefined
    );

  const parsed = useMemo(
    () => pipe(maybePersistedProtocolInstance, ProtocolInstance.decode),
    [maybePersistedProtocolInstance]
  );

  useEffect(() => {
    if (E.isLeft(parsed)) {
      console.error("Invalid protocol instance in local storage", {
        invalid: maybePersistedProtocolInstance,
        errors: parsed.left,
      });
      remove();
    }
  }, [parsed]);

  const nullable = pipe(parsed, O.fromEither, O.toUndefined);

  return [nullable, setPersistedProtocolInstance, remove] as const;
};
